// extracted by mini-css-extract-plugin
module.exports = {"p1":"admin-fee-drawer_p1___mlG5"};